import { useTranslations } from 'next-intl';
import { Alert } from '@/components/ui/alert';
import { useTelegram } from '@/_providers/telegram';

function ZoneAlert({ title }: { title?: string }) {
  const t = useTranslations();
  const { tg_chat_id } = useTelegram();

  return (
    <Alert
      w='360px'
      size='sm'
      rounded={12}
      variant='solid'
      status='error'
      title={title || t('address_not_in_service_area')}
    >
      {title && tg_chat_id && t('telegram_location_permission_warning')}
    </Alert>
  );
}

export default ZoneAlert;
